(function ($) {
  Drupal.behaviors.carousel = {
    attach: function (context, settings) {
      var ehCarousel = $('.eh-carousel', context);

      ehCarousel.each(function () {
        var thisFormatter = $(this);
        var flexsliderID = thisFormatter.children('.flexslider').attr('id');
        var flexslider = thisFormatter.find('#' + flexsliderID);

        // Initially hide the navigation for the carousel
        thisFormatter.find('.flex-direction-nav .flex-next').hide();
        thisFormatter.find('.flex-direction-nav .flex-prev').hide();

        // Check slides length and add items class if there are more than one slide
        var thisFlexSlider = thisFormatter.children('.flexslider');

        if (thisFlexSlider.find('.slides li').length > 1) {
	  // more than one slide
	  thisFlexSlider.addClass('items');
        } else {
	  // one slide
	  thisFlexSlider.addClass('item');
        }

        var slideshow = false;

        if (flexslider.hasClass('flexslider-slideshow')) {
	  slideshow = true;
        }
        var slidwidth = 710;

        if (thisFormatter.attr('data-slide-width') > 1) {
	  slidwidth = thisFormatter.attr('data-slide-width');
        }

        // style component should not occupy a slides content
        var otherElem = flexslider.find('.eh-internet-video-with-products').closest('.slides').find('li > :not(.eh-internet-video-with-products)');

        otherElem.addClass('hidden');
        otherElem.unwrap();

        flexslider.fitVids().flexslider({
	  animation: 'slide',
	  before: function (slider) {
	    // stop video
	    var currentSlide = slider.slides.eq(slider.currentSlide);
	    var currentFrame = currentSlide.find('iframe');
	    var currentFrameSrc = currentFrame.attr('src');

	    currentFrame.attr('src', '');
	    currentFrame.attr('src', currentFrameSrc);
	    // Remove previous image share overlays in this slider
	    slider.find('.share_close').trigger('click');

	    var videoCont = slider.find('.eh-internet-video-with-products');

	    if (videoCont.length) {
	      videoCont.find('video').each(function () {
                $(this).get(0).pause();
	      });
	    }
	  },
	  itemMargin: 0,
	  itemWidth: slidwidth,
	  start: function (slider) {
	    // Resize flexslider when first slide loads
	    slider.resize();
	    // Only align share icons for the images that are shareable
	    if (slider.find('.shareable').length > 1) {
	      $(window).trigger('eh_img_share_alignment');
	    }
	    slider.find('.loadingMask').hide();
	  },
	  minItems: 1,
	  maxItems: 1,
	  slideshow: slideshow,
	  video: true,
	  move: 1,
	  animationLoop: false
        });
        // When the slider content is loaded then hide the loading gif
        thisFormatter.find('.loadingMask').fadeOut();

        if (thisFormatter.hasClass('show-numbers')) {
	  var navigationLinkCount = thisFormatter.find('.flex-control-nav li').length;
	  var slideNumber = thisFormatter.find('.flex-active').html();
	  var pageNumberContainer = "<div class='pagination'>" + slideNumber + '/' + navigationLinkCount + '</div>';

	  thisFormatter.find('.flex-control-nav.flex-control-paging').append(pageNumberContainer);

	  thisFormatter.find('.flexslider .flex-direction-nav .flex-next')
	    .add(thisFormatter.find('.flexslider .flex-direction-nav .flex-prev')).on('click', function() {
	      slideNumber = thisFormatter.find('.flex-active').html();
	      if (slideNumber == 1) {
                thisFormatter.find('.flexslider .flex-viewport .slides').css({ 'marginLeft': '0px' });
	      }
	      if (slideNumber == navigationLinkCount) {
                thisFormatter.find('.flexslider .flex-viewport .slides').css({ 'marginLeft': '-360px' });
	      }
	      thisFormatter.find('.flex-control-nav.flex-control-paging .pagination').html(slideNumber + '/' + navigationLinkCount);
	    });
        }
      });

      // While loading image may not give exact size
      // so calculate once the window loads
      $(window).on('load', function() {
        fixFlexsliderHeight();
      });

      var carouselTimer = null;

      $(window).resize(function () {
        // debounced - Execute the functionality only once when the resize stops
        if (carouselTimer) {
          clearTimeout(carouselTimer);
        }
        // Only the last instant of the resize triggers
        carouselTimer = setTimeout(function () {
	  fixFlexsliderHeight();
        }, 50);
      });

      // This slider is used for game changer as well as in articles
      // so calculate the slider height based on its max height image
      function fixFlexsliderHeight() {
        // Set fixed height based on the tallest slide
        ehCarousel.find('.flexslider').each(function () {
	  var thisSlidesUl = $(this).find('ul.slides'),
	      sliderHeight = 0;

	  thisSlidesUl.find('> li img.article').each(function () {
	    slideHeight = $(this).height();
	    if (sliderHeight < slideHeight) {
	      sliderHeight = slideHeight;
	    }
	  });
	  var thisSlidesUl = $(this).find('ul.slides');

	  thisSlidesUl.css({ 'height': sliderHeight });
	  thisSlidesUl.find('> li').css({ 'height': sliderHeight });
        });
      }
    }
  };
})(jQuery);
